<template>
  <v-card
    id="screenContent"
    class="vetalfa-view"
    :max-width="_getMaxWidth()"
    flat
  >
    <div class="vetalfa-global-header" ref="screenHeader">
      <vetalfa-small-header
        showBreadCrumbAndTitle
        :title="_getLabel('VISUALIZE_PRESCRIPTION')"
        :breadcrumb="_getLabel('VISUALIZE_PRESCRIPTION')"
      ></vetalfa-small-header>
      <v-row no-gutters justify="center">
        <v-row no-gutters align="center" class="vetalfa-max-width">
          <v-col cols="12" class="ma-0 mt-3" v-if="files.length > 0">
            <v-tabs
              active-class="primary--text font-weight-bold"
              class="ma-0 pa-0 mx-4"
              slider-color="primary"
              v-model="pageModel"
              show-arrows
              :next-icon="mdiChevronRight"
              :prev-icon="mdiChevronLeft"
            >
              <v-tab
                class="text-none"
                v-for="(_file, index) in files"
                :key="`page${index}`"
                >{{ `${_getLabel("TAB_GUIDE")} ${parseInt(index) + 1}` }}</v-tab
              > </v-tabs
            ><v-divider></v-divider>
          </v-col>
        </v-row>
      </v-row>
    </div>
    <div ref="screenContent">
      <div v-if="files && files.length > 0" class="pdf-container">
        <component
          :is="pdfComponent"
          v-if="pdfComponent"
          :src="files[pageModel]"
          class="pdf-viewer"
          ref="pdfViewer"
        ></component>
        <v-row
          v-else-if="_isIos()"
          no-gutters
          justify="center"
          align="center"
          class="vetalfa-row"
          style="background-color: #ccc"
        >
          <v-btn
            @click="
              openExternalUrl({
                url: files[pageModel],
                inAppBrowser: true,
              })
            "
            rounded
            outlined
            color="primary"
            class="text-none vetalfa-pointer"
          >
            <v-icon small class="mr-2" color="primary">{{
              mdiEyeOutline
            }}</v-icon>
            Visualizar receita
          </v-btn>
        </v-row>
      </div>
      <v-row
        no-gutters
        justify="space-between"
        v-if="files.length"
        class="px-4 mt-6"
        :class="{ 'vetalfa-button-bottom-combo': _xsOnly() }"
      >
        <v-col cols="6" class="ma-0 pa-0 pr-2">
          <v-row no-gutters justify="start">
            <v-btn
              @click="secondActionMethod"
              class="text-none text-decoration-underline"
              color="primary"
              :block="_xsOnly()"
              small
              text
            >
              <v-icon small class="mr-2">{{
                shareDate ? mdiRepeatVariant : mdiChevronLeft
              }}</v-icon>
              {{ _getLabel(shareDate ? "REPEAT_PRESCRIPTION" : "BACK") }}
            </v-btn>
          </v-row>
        </v-col>
        <v-col cols="6" class="ma-0 pa-0 pl-2">
          <v-row no-gutters justify="end">
            <v-btn
              @click="continueToShare"
              class="text-none primary"
              rounded
              :block="_xsOnly()"
              :small="!!shareDate"
            >
              <v-icon small class="mr-2">{{ mdiShare }}</v-icon>
              {{ _getLabel(shareDate ? "SHARE" : "CONTINUE") }}
            </v-btn>
          </v-row>
        </v-col>
      </v-row>
      <vetalfa-dialog
        v-on:dialogClose="shareModel = false"
        :bottom="_xsOnly()"
        :toggleModel="shareModel"
        :fullscreen="false"
        max-width="700px"
        :height="dialogHeight"
        :smallHeader="false"
        :featureMode="false"
        background-color="secondary"
        :dialogHeader="{
          title: _getLabel('SHARE'),
        }"
      >
        <div v-if="!confirmEmailOrPhone">
          <v-row
            no-gutters
            v-if="clinicalHandouts && clinicalHandouts.length > 0"
            class="mt-5 px-3"
          >
            <v-expansion-panels
              flat
              class="mb-3 vetalfa-card-grey-border vetalfa-pointer"
            >
              <v-expansion-panel>
                <v-expansion-panel-header
                  dense
                  class="subtitle-2 py-0"
                  style="min-height: 40px !important"
                >
                  {{
                    `${_getLabel("CLINICAL_HANDOUTS_SELECTED")}: ${
                      selectedHandouts.length
                    }`
                  }}
                </v-expansion-panel-header>
                <v-expansion-panel-content class="py-3">
                  <v-list dense flat subheader>
                    <v-list-item-group
                      v-model="selectedHandouts"
                      multiple
                      active-class=""
                    >
                      <v-list-item
                        v-for="handout in clinicalHandouts"
                        :key="`handouts-${handout.id}`"
                      >
                        <template v-slot:default="{ active }">
                          <v-list-item-action>
                            <v-checkbox :input-value="active"></v-checkbox>
                          </v-list-item-action>
                          <v-list-item-content>
                            <v-list-item-title>{{
                              handout.name
                            }}</v-list-item-title>
                            <v-list-item-subtitle>
                              {{ getContentTypeName(handout.content_type) }}
                            </v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                        <v-divider></v-divider>
                      </v-list-item>
                    </v-list-item-group>
                  </v-list>
                </v-expansion-panel-content>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-row>
          <v-row
            no-gutters
            v-if="clinicalHandouts && clinicalHandouts.length > 0"
            justify="end"
            class="mb-8"
          >
            <v-btn
              text
              small
              color="primary"
              class="text-none text-decoration-underline"
              @click="showHowItWorks"
            >
              O que são os folhetos do tutor?
            </v-btn>
          </v-row>

          <v-row no-gutters class="px-4 mt-4 mb-0">
            <v-alert
              small
              outlined
              color="grey darken-1"
              class="vetalfa-card-grey-border ma-0"
              dismissible
              dense
            >
              <p
                class="caption grey--text text--darken-1 ma-0 pa-0"
                v-html="
                  'Caso existam medicamentos controlados, certifique-se de imprimir, carimbar e assinar duas vias da prescrição.<br>Em breve será possível habilitar integrações com suas Assinaturas Digitais.'
                "
              ></p>
            </v-alert>
          </v-row>
          <v-row no-gutters class="px-3 mt-4">
            <v-list dense class="secondary" style="width: 100%">
              <p class="primary--text">
                Como você deseja compartilhar com o tutor?
              </p>
              <v-list-item-group v-model="actionsModel" active-class="">
                <template v-for="(action, index) in shareActions">
                  <v-list-item :key="action.title">
                    <template v-slot:default="{ active }">
                      <v-list-item-action>
                        <v-checkbox :input-value="active"></v-checkbox>
                      </v-list-item-action>
                      <v-list-item-content>
                        <v-list-item-title>{{
                          action.title
                        }}</v-list-item-title>
                        <span
                          v-if="action.subtitle && active"
                          class="caption grey--text text--darken-1"
                        >
                          {{ action.subtitle }}
                        </span>
                      </v-list-item-content>
                      <v-list-item-icon>
                        <v-icon size="20" color="primary" class="mt-1">{{
                          action.icon
                        }}</v-icon>
                      </v-list-item-icon>
                    </template>
                  </v-list-item>

                  <v-divider
                    v-if="index < shareActions.length - 1"
                    :key="index"
                  ></v-divider>
                </template>
              </v-list-item-group>
            </v-list>
          </v-row>
        </div>
        <algorithms
          class="mt-6"
          :headerHeightOffset="50"
          v-if="confirmEmailOrPhone"
        >
        </algorithms>

        <template v-slot:actions>
          <v-row no-gutters>
            <v-col
              cols="12"
              v-if="!confirmEmailOrPhone"
              no-gutters
              class="mb-5 mt-7"
            >
              <v-row no-gutters justify="center">
                <v-btn
                  :disabled="actionsModel === undefined"
                  rounded
                  class="primary text-none px-7"
                  @click="sharePrescriptionWithOwner(false)"
                >
                  {{ _getLabel("CONTINUE") }}
                </v-btn>
              </v-row>
            </v-col>
          </v-row>
        </template>
      </vetalfa-dialog>
    </div>
  </v-card>
</template>

<script>
import {
  mdiChevronLeft,
  mdiChevronRight,
  mdiShare,
  mdiPrinterOutline,
  mdiRepeatVariant,
  mdiEmailOutline,
  mdiContentSaveOutline,
  mdiAlertCircleOutline,
  mdiLink,
  mdiEyeOutline,
} from "@mdi/js";
import { mapActions, mapGetters, mapMutations } from "vuex";
import Algorithms from "@/algorithms/Algorithms.vue";
const SHARE_ACTIONS = {
  PRINT: 1,
  EMAIL: 2,
  WHATSAPP: 3,
  SAVE: 4,
  COPY: 5,
};
export default {
  name: "PrescriptionsSummary",
  components: {
    algorithms: Algorithms,
  },
  data() {
    return {
      pageModel: 0,
      mdiChevronLeft,
      mdiChevronRight,
      mdiRepeatVariant,
      mdiContentSaveOutline,
      mdiAlertCircleOutline,
      mdiLink,
      mdiEyeOutline,
      mdiShare,
      shareModel: false,
      selectedHandouts: [],
      confirmEmailOrPhone: false,
      prescriptionPages: [],
      patient: null,
      actionsModel: undefined,
      dialogHeight: null,
      downloadedFiles: [],
      pdfComponent: null,
    };
  },
  computed: {
    ...mapGetters("prescriptions", ["files", "shareDate", "clinicalHandouts"]),
    ...mapGetters("patients", ["owner"]),
    ...mapGetters("algorithms", ["flowEndTrigger", "getModels"]),
    shareActions() {
      let actions = [];
      if (!this._isCordovaApp()) {
        actions.push({
          icon: mdiContentSaveOutline,
          title: this._getLabel("SAVE_FILES"),
          type: SHARE_ACTIONS.SAVE,
        });
      }
      if (!this._isMobile()) {
        actions.push({
          icon: mdiPrinterOutline,
          title: this._getLabel("PRINT"),
          type: SHARE_ACTIONS.PRINT,
          subtitle: "Suas guias serão impressas em ordem uma por vez.",
        });
      }
      actions.push({
        icon: mdiEmailOutline,
        title: "Compartilhar por E-mail",
        type: SHARE_ACTIONS.EMAIL,
        subtitle:
          "Enviaremos o link de acesso para o e-mail do tutor selecionado.",
      });
      actions.push({
        icon: this._icon("whatsapp"),
        title: this._getLabel("WHATSAPP"),
        type: SHARE_ACTIONS.WHATSAPP,
        subtitle:
          "Se você não for redirecionado, verifique o bloqueio de pop-ups ou copie o link abaixo e envie para o tutor.",
      });
      actions.push({
        icon: mdiLink,
        title:
          navigator.share && this._isMobile()
            ? "Compartilhar Link"
            : "Copiar link para envio manual",
        type: SHARE_ACTIONS.COPY,
        subtitle: this._isCordovaApp()
          ? "Você pode copiar o link de acesso e compartilhar com o Whatsapp e outros aplicativos do seu dispositivo."
          : null,
      });
      return actions;
    },
  },
  methods: {
    ...mapMutations("prescriptions", ["setPrescription"]),
    ...mapMutations("general", ["setConfirmModel"]),
    ...mapActions("prescriptions", [
      "getPrescriptionDetailsAndGenFilesAction",
      "goToPrescriptionsDraftEditionAction",
      "getAvailableClinicalHandoutsAction",
      "postPrescriptionShareAction",
      "repeatPrescriptionAction",
      "clearPrescriptionAction",
    ]),
    ...mapActions("general", [
      "displayHelpArticle",
      "logEvent",
      "openExternalUrl",
    ]),
    ...mapActions("patients", [
      "confirmOwnerEmailAlgorithm",
      "confirmOwnerPhoneAlgorithm",
      "confirmOwnerPhoneAndEmailAlgorithm",
    ]),
    async sharePrescriptionWithOwner(hasRegistrationConfirmation = false) {
      const type = this.shareActions[this.actionsModel].type;
      const hasEmail = type === SHARE_ACTIONS.EMAIL;
      const hasWhatsapp = type === SHARE_ACTIONS.WHATSAPP;
      const hasPrinting = type === SHARE_ACTIONS.PRINT;
      const hasSave = type === SHARE_ACTIONS.SAVE;
      if (hasEmail && hasWhatsapp && !hasRegistrationConfirmation) {
        this.confirmEmailOrPhone = true;
        return this.confirmOwnerPhoneAndEmailAlgorithm();
      } else if (hasEmail && !hasRegistrationConfirmation) {
        this.confirmEmailOrPhone = true;
        return this.confirmOwnerEmailAlgorithm();
      } else if (hasWhatsapp && !hasRegistrationConfirmation) {
        this.confirmEmailOrPhone = true;
        return this.confirmOwnerPhoneAlgorithm();
      }
      await this.postPrescriptionShareAction({
        type,
        clinicalHandouts: this.clinicalHandouts.filter((_handout, index) =>
          this.selectedHandouts.includes(index)
        ),
        email: this.getModels.email || undefined,
        phone: this.getModels.phone || undefined,
      });
      this.shareModel = false;
      if (hasPrinting) {
        this.printAction();
      }
      if (hasSave) {
        this.saveAction();
      }
    },
    showHowItWorks() {
      this.logEvent("handouts_how_it_works");
      this.displayHelpArticle({ id: process.env.VUE_APP_FAQ_HANDOUTS });
    },
    secondActionMethod() {
      if (this.shareDate) {
        this.repeatPrescriptionAction({
          patient: this.patient,
          prescription: this.prescriptionPages,
        });
      } else {
        this.goToPrescriptionsDraftEditionAction();
      }
    },
    getContentTypeName(content_type) {
      return this._getLabel(
        {
          1: "SYSTEMIC_DRUGS",
          2: "DERMATOLOGICAL_TOPICS",
          3: "OPTHALMIC_AGENTS",
          4: "DISEASES_AND_TREATMENT",
        }[content_type]
      );
    },
    async continueToShare() {
      if (!this.shareDate) {
        this.setConfirmModel({
          text: this._getLabel("PRESCRIPTION_SHARE_CONFIRMATION"),
          callback: async () => {
            const { patient, prescription } =
              await this.getPrescriptionDetailsAndGenFilesAction({
                prescriptionId: this.$route.params.id,
                hasShareDate: true,
              });
            this.patient = patient;
            this.prescriptionPages = prescription;
            this.continueToShare();
          },
          confirmText: this._getLabel("SHARE"),
          closeText: this._getLabel("CANCEL"),
        });
      } else {
        await this.getAvailableClinicalHandoutsAction();
        this.selectedHandouts = [];
        this.clinicalHandouts.forEach((handout, index) => {
          this.selectedHandouts.push(parseInt(index));
        });
        this.shareModel = this._getTimestamp();
      }
    },
    downloadFiles() {
      this.downloadedFiles = [];
      if (!this._isCordovaApp()) {
        this.files.forEach((file, index) => {
          fetch(file)
            .then((response) => response.blob())
            .then((blob) => {
              const file = new File([blob], `Receita ${index + 1}.pdf`, {
                type: "application/pdf",
              });
              this.downloadedFiles.push(file);
            })
            .catch((err) =>
              console.error(
                "An error occurred while generating the download:",
                err
              )
            );
        });
      }
    },
    async printAction(pageModel = 0) {
      this.pageModel = pageModel;
      this.setConfirmModel({
        text: `Vamos imprimir uma guia por vez. Para continuar confirme abaixo a impressão da Guia ${
          pageModel + 1
        }.`,
        callback: async () => {
          this.$refs.pdfViewer.print();
          await new Promise((resolve) => setTimeout(resolve, 1000));
          if (this.files.length > pageModel + 1) {
            this.printAction(pageModel + 1);
          }
        },
        confirmText: `Imprimir guia ${pageModel + 1}`,
        closeText: this._getLabel("CANCEL"),
      });
    },
    async saveAction() {
      if ((this._isMobile() || this._isCordovaApp()) && navigator.share) {
        navigator
          .share({
            title: "Receitas salvas",
            files: this.downloadedFiles,
          })
          .catch(console.error);
      } else {
        this.downloadedFiles.forEach((file, index) => {
          const a = document.createElement("a");
          a.href = URL.createObjectURL(file);
          a.download = `Receita ${index + 1}.pdf`;
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          URL.revokeObjectURL(a.href);
        });
      }
    },
  },
  watch: {
    shareModel() {
      this.confirmEmailOrPhone = false;
    },
    flowEndTrigger() {
      this.sharePrescriptionWithOwner(true);
    },
    files(val) {
      if (val && val.length > 0) {
        this.downloadFiles();
      }
    },
  },
  async created() {
    if (!this.pdfComponent && !this._isIos()) {
      this.pdfComponent = (await import("vue-pdf")).default;
    }
  },
  async mounted() {
    await this.clearPrescriptionAction();
    const { patient, prescription } =
      await this.getPrescriptionDetailsAndGenFilesAction({
        prescriptionId: this.$route.params.id,
      });
    this.patient = patient;
    this.prescriptionPages = prescription;
    this._setupScreenSizes(this);
    this.dialogHeight = this._getDialogHeight(this._isIos() ? 0.9 : 0.95);
  },
};
</script>

<style scoped>
.pdf-container {
  height: calc(100vh - 350px);
  overflow: auto;
  transition: height 0.3s;
  margin: 0 16px 0 16px;
  border: 1px solid #ccc;
  border-radius: 5px;
  max-height: 842px;
}

.pdf-viewer {
  width: 100%;
  height: 100%;
}
</style>
